// src/utils/authCookies.ts
import { setCookie, getCookie } from 'cookies-next';

/**
 * @deprecated due move to use AuthStore.
 * Can be get manually but need to change to parse json of store
 */
export function getAccessToken(): string {
  return typeof window !== 'undefined' ? (getCookie('accessToken') as string) : '';
}

export interface AuthCookieOptions {
  accessToken: string;
}

export function setAuthCookies({ accessToken }: AuthCookieOptions) {
  setCookie('accessToken', accessToken, {
    secure: true,
    sameSite: 'strict',
  });
}

export function clearAuthCookies() {
  setCookie('accessToken', '', { maxAge: 0, path: '/' });
}
